/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OverrideJustificationArtefact } from './OverrideJustificationArtefact';
import {
  OverrideJustificationArtefactFromJSON,
  OverrideJustificationArtefactFromJSONTyped,
  OverrideJustificationArtefactToJSON,
} from './OverrideJustificationArtefact';

/**
 *
 * @export
 * @interface PatchedOverrideJustification
 */
export interface PatchedOverrideJustification {
  /**
   *
   * @type {number}
   * @memberof PatchedOverrideJustification
   */
  readonly id?: number;
  /**
   *
   * @type {string}
   * @memberof PatchedOverrideJustification
   */
  description?: string | null;
  /**
   *
   * @type {Array<OverrideJustificationArtefact>}
   * @memberof PatchedOverrideJustification
   */
  readonly artefacts?: Array<OverrideJustificationArtefact>;
}

/**
 * Check if a given object implements the PatchedOverrideJustification interface.
 */
export function instanceOfPatchedOverrideJustification(value: object): value is PatchedOverrideJustification {
  return true;
}

export function PatchedOverrideJustificationFromJSON(json: any): PatchedOverrideJustification {
  return PatchedOverrideJustificationFromJSONTyped(json, false);
}

export function PatchedOverrideJustificationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PatchedOverrideJustification {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'] == null ? undefined : json['id'],
    description: json['description'] == null ? undefined : json['description'],
    artefacts:
      json['artefacts'] == null
        ? undefined
        : (json['artefacts'] as Array<any>).map(OverrideJustificationArtefactFromJSON),
  };
}

export function PatchedOverrideJustificationToJSON(
  value?: Omit<PatchedOverrideJustification, 'id' | 'artefacts'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {
    description: value['description'],
  };
}
